'use client'

import { useLocale } from '@/features/i18n/hooks/useLocale'
// TODO: Truborepoが対応したらSCSSに変更する
// TODO: ts-ignoreをなくす
// @ts-ignore
import styles from 'ui/src/styles/components/partsGroups/Footer.module.scss'

export default function ResearcherFooter({ className }: { className?: string }) {
  const { t } = useLocale()

  return (
    <>
      <footer>
        <nav className={styles.footer__nav}>
          <ul>
            <li>
              <a href="https://coanexus.com/terms/" target="_blank">{t.footer.Terms}</a>
            </li>
            {/* <li>
              <a href="https://srust.co.jp/privacy-policy/">{t.footer.Disclaimer}</a>
            </li> */}
          </ul>
          <span className={styles.footer__copyright}>
          &copy; 2024 CoA Nexus.inc All rights reserved.
          </span>
        </nav>
      </footer>
    </>
  )
}
